import { db } from '../firebase';
import { 
  collection, 
  getDocs, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  doc, 
  query, 
  orderBy, 
  getDoc,
  serverTimestamp 
} from 'firebase/firestore';

const NOTICE_COLLECTION = 'E2B_NOTICES';

export const noticeService = {
  // 1. 전체 공지사항 목록 가져오기 (최신순)
  getNotices: async () => {
    try {
      const q = query(collection(db, NOTICE_COLLECTION), orderBy('createdAt', 'desc'));
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (e) {
      console.error("공지 로드 실패:", e);
      return [];
    }
  },

  // 2. 대시보드 노출용 공지사항만 가져오기
  getVisibleNotices: async () => {
    try {
      const allNotices = await noticeService.getNotices();
      return allNotices.filter(n => n.isVisible === true);
    } catch (e) {
      return [];
    }
  },

  // 3. 신규 공지 등록
  addNotice: async (noticeData) => {
    try {
      await addDoc(collection(db, NOTICE_COLLECTION), {
        ...noticeData,
        isVisible: true, // 기본 노출
        regDate: new Date().toLocaleDateString(), 
        createdAt: serverTimestamp() 
      });
    } catch (e) {
      console.error("공지 저장 실패:", e);
      throw e;
    }
  },

  // 4. 공지 내용 수정
  updateNotice: async (id, updateData) => {
    try {
      const docRef = doc(db, NOTICE_COLLECTION, id);
      await updateDoc(docRef, {
        ...updateData,
        updatedAt: serverTimestamp()
      });
    } catch (e) {
      console.error("공지 수정 실패:", e);
      throw e;
    }
  },

  // 5. 노출 여부(isVisible) 즉시 토글
  toggleVisibility: async (id) => {
    try {
      const docRef = doc(db, NOTICE_COLLECTION, id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        await updateDoc(docRef, { isVisible: !docSnap.data().isVisible });
      }
    } catch (e) {
      console.error("노출 설정 실패:", e);
    }
  },

  // 6. 공지 삭제
  deleteNotice: async (id) => {
    try {
      await deleteDoc(doc(db, NOTICE_COLLECTION, id));
    } catch (e) {
      console.error("공지 삭제 실패:", e);
    }
  }
};